function toogleMenuBurguer() {
    const buttonBurguer = document.getElementById("nav-button-burguer-menu");
    const navMenu = document.getElementById("nav-menu-mobile");

    if (buttonBurguer) {
        buttonBurguer.addEventListener("click", function() {
            if (navMenu) {
                buttonBurguer.classList.toggle("active");
                navMenu.classList.toggle("active");
            }
        });
    }
}

function toogleItemNav() {
    const itemNav = document.querySelectorAll("header .nav-menu-mobile ul.nav-link li.nav-item");

    if (itemNav.length > 0) {
        for (let i = 0; i < itemNav.length; i++) {
            itemNav[i].addEventListener("click", function() {
                itemNav[i].classList.toggle("active");

                for (let j = 0; j < itemNav.length; j++) {
                    if (j !== i) {
                        itemNav[j].classList.remove("active");
                    }
                }
            });
        }
    }
}

function toggleSearch() {
    const iconSearch = document.querySelector("header #icon-search");
    if (iconSearch) {
        const openSearch = iconSearch.querySelector(".search-open");
        const closeSearch = iconSearch.querySelector(".search-close");
        const wrapSearch = document.querySelector("header .nav-search");

        if (openSearch) {
            openSearch.addEventListener("click", function() {
                if (wrapSearch) {
                    wrapSearch.classList.add("active");
                }

                iconSearch.style.background = "#ffffff";
                openSearch.style.display = "none";
                if (closeSearch) {
                    closeSearch.style.display = "flex";
                }
            });
        }

        if (closeSearch) {
            closeSearch.addEventListener("click", function() {
                if (wrapSearch) {
                    wrapSearch.classList.remove("active");
                }

                iconSearch.style.background = "transparent";
                closeSearch.style.display = "none";
                if (openSearch) {
                    openSearch.style.display = "flex";
                }
            });
        }

        // nav-item
        const itemNav = document.querySelectorAll("header .nav-menu-desktop ul.nav-link li.nav-item");

        if (itemNav.length > 0) {
            for (let i = 0; i < itemNav.length; i++) {
                itemNav[i].addEventListener("mouseover", function() {
                    // hidden search
                    if (wrapSearch) {
                        wrapSearch.classList.remove("active");
                    }

                    iconSearch.style.background = "transparent";
                    if (closeSearch) {
                        closeSearch.style.display = "none";
                    }
                    if (openSearch) {
                        openSearch.style.display = "flex";
                    }
                });
            }
        }
    }
}

function scrollNav() {
    let lastScrollTop = 0;
    const header = document.querySelector("header");

    window.addEventListener("scroll", function() {
        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll > lastScrollTop && currentScroll > 100) {
            header.classList.add("hiddenHeader");
        } else {
            header.classList.remove("hiddenHeader");
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
}
function init() {
    toogleMenuBurguer();
    toogleItemNav();
    toggleSearch();
    scrollNav();
}

export default { init };
